module.exports = __webpack_public_path__ + "static/media/vivaticket-bg.abd162a9.jpg";